var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-form-item',[_c('base-select',{directives:[{name:"decorator",rawName:"v-decorator",value:(_vm.decorator),expression:"decorator"}],attrs:{"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }